export default "__VITE_ASSET__BkGrTERh__"